import { render, staticRenderFns } from "./collapsible-with-items.vue?vue&type=template&id=626757ec&scoped=true"
import script from "./collapsible-with-items.vue?vue&type=script&lang=js"
export * from "./collapsible-with-items.vue?vue&type=script&lang=js"
import style0 from "./collapsible-with-items.vue?vue&type=style&index=0&id=626757ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626757ec",
  null
  
)

export default component.exports